import { Action } from '../../../redux/redux.types';
import { VIDEO_PLAYER_PLAYBACK_ACTIONS } from './video-player.actions';

export interface VideoPlayerState {
  isPlaying: boolean;
}

const defaultState: VideoPlayerState = {
  isPlaying: false,
};

export const videoPlayer = (
  state: VideoPlayerState = defaultState,
  { type }: Action,
) => {
  switch (type) {
    case VIDEO_PLAYER_PLAYBACK_ACTIONS.VIDEO_PLAYBACK_STARTED:
      return {
        isPlaying: true,
      };

    case VIDEO_PLAYER_PLAYBACK_ACTIONS.VIDEO_PLAYBACK_STOPPED:
      return {
        isPlaying: false,
      };

    default:
      return state;
  }
};
